export default {
    finalize() {
        setTimeout(() => {
            window.google.maps.event.addDomListener(window, 'load', this.initMap())
        }, 500)
    },
    initMap() {
        const block = $('.contact__map')
        const container = block.find('.map')
        const locations = JSON.parse(JSON.stringify(block.data('locations')))
        const styles = JSON.parse(JSON.stringify(block.data('style')))
        const style = [{
            width: 55,
            height: 62,
            url: '',
            textColor: '#ffffff',
            textSize: 20,
        }]

        let map = new window.google.maps.Map(container[0], {
            zoom: 3,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            center: new window.google.maps.LatLng(-39.91, 116.38),
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: {
                mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
            },
        })

        const styledMapType = new window.google.maps.StyledMapType(styles)
        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        this.refreshMap(map, locations, style);
        this.zoomMap(map);
    },
    refreshMap(map, locations, style) {
        let markers = [];

        if (locations.length) {
            for (let i = 0; i < locations.length; i++) {
                let obj = locations[i];

                // let markerImage = {
                //     url: '',
                //     size: new window.google.maps.Size(70, 76),
                //     origin: new window.google.maps.Point(0, 0),
                //     scaledSize: new window.google.maps.Size(60, 65),
                // };

                let marker = new window.google.maps.Marker({
                    position: new window.google.maps.LatLng(obj.address['lat'], obj.address['lng']),
                    title: obj.title,
                    //icon: markerImage,
                });

                this.infoWindow(obj, marker);
                markers.push(marker);
            }
        }

        new window.MarkerClusterer(map, markers, {
            maxZoom: 12,
            gridSize: 50,
            styles: style,
        });

    },
    infoWindow(obj, marker) {
        const directions = 'https://www.google.com.au/maps/dir/' + obj.address['lat'] + ',' + obj.address['lng'];
        const phone = (obj.phone) ? '<p>Ph. ' + obj.phone + '</p>' : '';
        const content = '<div class="pin-content">' +
            '<h3 class="large-text">' + obj.title + '</h3><p>' +
            obj.address['address'] + '</p>' + phone +
            '<a href="' + directions +
            '" target="_blank">Get Directions</a></div>';

        const infoWindow = new window.google.maps.InfoWindow({
            content: content,
        });

        marker.addListener('click', function () {

            if (Map.info) {
                Map.info.close();
            }

            Map.info = infoWindow;

            infoWindow.open(this.map, marker);
        });
    },
    zoomMap(map) {
        window.google.maps.event.addListener(map, 'zoom_changed', function () {
            if (this.getZoom() < 2) {
                this.setZoom(2);
            }
        });
    },
}


// WEBPACK FOOTER //
// /home/pentarchcom/public_html/website/web/app/themes/main-theme/resources/assets/scripts/routes/contact.js